import React from 'react'
import SkeletonWrapper from "../../UI/skeletonWrapper";

const FeatureToggle = ({ label, name, checked, onChange, isLoading ,desc }) => (
  <div className="col-12 d-flex justify-content-between align-items-center mt-4 mb-4">
    <div>
      <h5 className="font16 text-smoke mb-1" data-test-id={`feature-label-${name}`}>{label}</h5>
      <p className='desc'>{desc}</p>
    </div>
    <label className="switch">
     
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          data-test-id={`form-feature-toggle-${name}`}
        />
    
      <span className="slider round"></span>
    </label>
  </div>
);

export default FeatureToggle
